<div class="el-contact-wrapper payment-suc vh-100  d-flex justify-content-center align-items-center">
  <div class="payment-success-container">
    <div class="el-contact-form-box el-blog-single my-order p-5">
      <!-- <div class="success-icon">&#10004;</div> -->
      <div class="success-animation">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      </div>
      <h2 class="text-success"> Payment Successful!</h2><br>
      <p>Your payment for PowerPrep is successful. Get ready to power up your Olympiad preparation!</p>
      <p><strong>Order Number:</strong> {{ orderId }}</p><br><br>

      <a class="el-btn" [routerLink]="['/']"> Go to Home &nbsp;<i class="fa fa-home"> </i></a>&nbsp;&nbsp;
      <a class="el-btn" [routerLink]="['/MyPlan']"> Go to My Plan &nbsp;<i class="fa fa-shopping-bag"> </i></a>
    </div>
  </div>
</div>